export default __webpack_public_path__ + "static/media/before@2x.016ea6cc.png";